/**
 * LegalFooter.js
 * Enlaces legales. Deben ser accesibles desde cualquier punto del servicio,
 * tanto para coaches como para familias (exigencia de la LSSI-CE: el aviso
 * legal ha de estar disponible de forma permanente, fácil y gratuita).
 */
import React from 'react';
import { Link } from 'react-router-dom';

const LINKS = [
  { to: '/aviso-legal', label: 'Aviso legal' },
  { to: '/privacidad', label: 'Privacidad' },
  { to: '/cookies', label: 'Cookies' },
  { to: '/terminos', label: 'Términos' },
];

export default function LegalFooter({ compact = false }) {
  return (
    <footer style={{ ...S.footer, ...(compact ? S.compact : null) }}>
      <nav style={S.nav}>
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to} style={S.link}>{l.label}</Link>
        ))}
      </nav>
      {!compact && (
        <span style={S.copy}>© {new Date().getFullYear()} MiCoach</span>
      )}
    </footer>
  );
}

const S = {
  footer: {
    display: 'flex', flexWrap: 'wrap', alignItems: 'center',
    justifyContent: 'space-between', gap: '0.6rem',
    padding: '1rem 1.15rem',
    borderTop: '1px solid var(--border-subtle, rgba(255,255,255,0.055))',
    marginTop: 'auto',
  },
  compact: { padding: '0.75rem 1rem', justifyContent: 'center' },
  nav: { display: 'flex', flexWrap: 'wrap', gap: '0.9rem' },
  link: {
    fontSize: '0.72rem', textDecoration: 'none',
    color: 'var(--text-2, rgba(240,242,245,0.52))',
  },
  copy: { fontSize: '0.72rem', color: 'var(--text-2, rgba(240,242,245,0.52))' },
};
